import styled from "styled-components";

const PagerContainer = styled.div`
  padding-bottom: 30px;
`;

export default PagerContainer;
